import React, { Component } from 'react';
import {Link} from "react-router-dom";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {withStyles} from "@material-ui/styles";
import styles from "./styles/ColorBoxStyles";

class ColorBox extends Component{
    constructor(props){
        super(props);
        this.state={copied:false};
        this.changeCopyState=this.changeCopyState.bind(this);
    }
    changeCopyState(){
        this.setState({copied:true},()=>{
            setTimeout(()=>this.setState({copied:false}),1000)
        })
    }
    render(){
        const {background,name,moreUrl,showFullPalette,classes}=this.props;
        return( 
        <CopyToClipboard text={background} onCopy={this.changeCopyState}>
            <div className={classes.colorBox} style={{background}}>
                <div style={{background}} className={`${classes.copyOverlay} ${this.state.copied && classes.showOverlay}` }/>
                <div className={`${classes.copyMsg} ${this.state.copied && classes.showCopyMsg}`}>
                    <h1>copied!!!</h1>
                    <p className={classes.copyText}>{background}</p>
                </div>
                <div>
                    <div className={classes.boxContent}>
                        <span className={classes.colorName}>{name}</span>
                    </div>
                <button className={classes.copyButton}>Copy</button>
                </div>
                {showFullPalette && <Link to={moreUrl} onClick={e=>e.stopPropagation()}>
                    <span className={classes.seeMore}>More</span>
                </Link>}
            </div>
        </CopyToClipboard>
    );
    }
}
export default withStyles(styles)(ColorBox);